// ─── ACTION TYPE CONSTANTS ────────────────────────────────────────────────────
// String constants for all reducer actions.
// Using constants prevents typo bugs in dispatch() calls.

// Generic
export const SET_KEY   = 'SET_KEY';
export const SET_BATCH = 'SET_BATCH';
export const SET_TASK  = 'SET_TASK';

// Refs / File
export const SET_REFERENCE_URL_AND_INVALIDATE = 'SET_REFERENCE_URL_AND_INVALIDATE';
export const SET_SITEMAP_URL_AND_CLEAR       = 'SET_SITEMAP_URL_AND_CLEAR';

// Upload Bundle
export const SET_UPLOAD_BUNDLE_LOADING = 'SET_UPLOAD_BUNDLE_LOADING';
export const SET_UPLOAD_BUNDLE_FILES   = 'SET_UPLOAD_BUNDLE_FILES';
export const SET_UPLOAD_BUNDLE_ERROR   = 'SET_UPLOAD_BUNDLE_ERROR';

// Output / History
export const DELETE_HISTORY_ENTRY  = 'DELETE_HISTORY_ENTRY';
export const CLEAR_CONTENT_MEMORY  = 'CLEAR_CONTENT_MEMORY';

// Reset
export const FULL_RESET = 'FULL_RESET';
